<template>
  <v-menu
    offset-x
    max-width="350"
    min-width="300"
    max-height="455"
    v-model="menuOpened"
    :close-on-content-click="true"
    content-class="menu-overflow"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-badge
        color="secondary"
        overlap
        bottom
        left
      >
        <template v-slot:badge>
          <span>{{ produtos.length }}</span>
        </template>
        <v-btn icon small class="mr-3"
               v-on="on">
          <v-icon>mdi-cart</v-icon>
        </v-btn>
      </v-badge>
    </template>

    <v-card v-if="loading" class="text-center" style="overflow-y: hidden">
      <v-card-text>
        <px-circular-loading/>
      </v-card-text>
    </v-card>
    <v-card v-if="!loading">
      <v-list class="list-overflow" max-height="400">
        <v-list-item v-if="!produtos.length">
          <v-list-item-content align="center">
            <v-list-item-title>
              Não há produtos no carrinho
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-for="(item) in produtos">
          <v-list-item three-line :key="item.produto.id">
            <v-list-item-content>
              <v-list-item-title>
                <px-produto-descricao
:especificacao="item.produto.respostaCotacaoProduto.cotacaoProduto.especificacaoProduto"
                  :produto="item.produto.respostaCotacaoProduto.cotacaoProduto.produto"/>
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.identificador }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item.fornecedor.pessoa.nome }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="hasRoleComprador">
              <v-btn icon @click="removeItem(item.produto.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider :key="`div${item.produto.id}`"/>
        </template>
      </v-list>
      <v-card-actions>
        <v-btn block link class="normal-btn-text elevation-0 rounded-tag-small"
               color="primary" to="/carrinho">
          Ir para o carrinho
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { GET_ITENS, REMOVE_ITEM } from '@/store/carrinho/actions.type';
import { flatten } from 'lodash';

export default {
  data: () => ({
    menuOpened: false,
  }),
  computed: {
    ...mapGetters('carrinho', ['itens', 'loading']),
    ...mapGetters('user', ['hasRoleComprador']),
    produtos() {
      return flatten(this.itens.map(item => item.produtos
        .map(produto => ({
          produto,
          fornecedor: item.respostaCotacao.fornecedor,
          identificador: item.respostaCotacao.cotacao.identificador,
        }))));
    },
  },
  methods: {
    ...mapActions('carrinho', {
      getItens: GET_ITENS,
      removeItem: REMOVE_ITEM,
    }),
  },
  created() {
    this.getItens();
  },
};
</script>

<style scoped>
.menu-overflow {
  overflow-y: hidden;
}

.list-overflow {
  overflow-y: scroll;
}
</style>
